import { useMsal } from '@azure/msal-react';
import { useNavigate, useLocation } from 'react-router-dom';

interface Props {
    children: React.ReactNode;
}

export default function AdminLayout({ children }: Props) {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const location = useLocation();

    const user = accounts[0];

    const handleLogout = () => {
        instance.logoutRedirect().catch(console.error);
    };

    return (
        <div style={styles.root}>
            {/* Top nav */}
            <div style={styles.topNav}>
                <div style={styles.navLeft}>
                    <div style={styles.logoWrapper} onClick={() => navigate('/admin/clubs')}>
                        <img
                            src="/logo.png"
                            alt="19thView"
                            style={styles.logoImg}
                        />
                        <span style={styles.logoSub}>Admin</span>
                    </div>
                    <nav style={styles.nav}>
                        <button
                            style={{
                                ...styles.navItem,
                                ...(location.pathname.startsWith('/admin/clubs')
                                    ? styles.navItemActive : {})
                            }}
                            onClick={() => navigate('/admin/clubs')}
                        >
                            Clubs
                        </button>
                    </nav>
                </div>
                <div style={styles.navRight}>
                    <div style={styles.userName}>
                        {user?.name ?? user?.username}
                    </div>
                    <button style={styles.logoutBtn} onClick={handleLogout}>
                        Sign out
                    </button>
                </div>
            </div>

            {/* Main content */}
            <div style={styles.main}>
                {children}
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    root: {
        minHeight: '100vh',
        background: '#f5f6fa',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    topNav: {
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: '#1a6b3c',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        height: 56,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
    navLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 32,
    },
    logo: {
        fontSize: 20,
        fontWeight: 900,
        color: '#fff',
        letterSpacing: -0.5,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    logoWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
    },
    logoImg: {
        height: 32,
        width: 'auto',
        objectFit: 'contain',
    },
    logoSub: {
        fontSize: 11,
        fontWeight: 600,
        color: 'rgba(255,255,255,0.5)',
        letterSpacing: 1,
        textTransform: 'uppercase' as const,
    },    
    nav: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    navItem: {
        background: 'none',
        border: 'none',
        color: 'rgba(255,255,255,0.7)',
        fontSize: 14,
        fontWeight: 500,
        padding: '6px 14px',
        borderRadius: 6,
        cursor: 'pointer',
        transition: 'all 0.15s',
    },
    navItemActive: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        fontWeight: 700,
    },
    navRight: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    },
    userName: {
        fontSize: 13,
        color: 'rgba(255,255,255,0.7)',
    },
    logoutBtn: {
        background: 'rgba(255,255,255,0.1)',
        border: '1px solid rgba(255,255,255,0.2)',
        color: '#fff',
        fontSize: 13,
        padding: '5px 12px',
        borderRadius: 6,
        cursor: 'pointer',
        fontWeight: 500,
    },
    main: {
        padding: '24px',
        maxWidth: 1200,
        margin: '0 auto',
    },
};